import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { HelpSiteMessage } from "@shared/models/analytics/help-site"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {
  searchQuery: string | false
  locationOfAction: "contact_us_page" | "search_box"
}

export default function sendUsAMessageAction(payload: Payload): PreparedAction {
  return {
    name: "KB_SEND_US_A_MESSAGE",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: HelpSiteMessage = {
    ...createBlankEvent(),
    root_id: "help_site",
    root_type: "app",

    primary_verb: "use",

    primary_object_type: "app",
    primary_object_id: "help_site",
    primary_object_specifier: payload.locationOfAction,
    primary_object_id_and_ancestor_ids: ["help_site"],

    adverbial_verb: "sending",

    adverbial_object_type: "message",
    adverbial_object_id_and_ancestor_ids: ["help_site"],
  }
  return createNarrative({
    title: "Sent a Message",
    description: `User contacted us through the ${payload.locationOfAction}`,
    titleForAnalytics: "KB Article - Visit",
    context: {
      searchQuery: payload.searchQuery,
    },
    newAnalyticsEvents: [newEvent],
  })
}
